import { useOutletContext } from 'react-router'
import { useDispatch } from 'react-redux'
import { showLoader } from '@data/state/action'
import { displayWeight } from '@utils'
import { PageLevelTableWrapper, SectionHeader } from '@base'
import { Table as TableV2 } from '@baseV2'
import { strings } from '@constants'
import { getDetailedDispatchReport, getDispatchReportByPlatform } from '@data'
import React, { useEffect, useMemo, useState } from 'react'
import { TableContainer, Wrapper } from '../style'

const ReportsList = () => {
	const { planDate } = useOutletContext()
	const dispatch = useDispatch()
	const [reportByPlatform, setReportByPlatform] = useState([])
	const [reportBydDispatch, setReportBydDispatch] = useState([])
	useEffect(() => {
		dispatch(showLoader(true))

		Promise.all([getDispatchReportByPlatform(planDate), getDetailedDispatchReport(planDate)])
			.then(([platformRes, detailedRes]) => {
				setReportByPlatform(platformRes)
				setReportBydDispatch(detailedRes)
			})
			.catch((err) => console.log(err))
			.finally(() => {
				dispatch(showLoader(false))
			})
	}, [planDate])

	const displayItem = (item) => (item ? `${displayWeight(item)}` : '-')

	const reportByPlatformColumns = useMemo(() => {
		return [
			{
				label: strings('platform'),
				key: (item) => item.platform ?? '-',
				mobile: true,
			},
			{
				label: strings(['total', 'planned', 'quty']),
				key: (item) => displayItem(item.total_planned_quantity),
				mobile: true,
			},
			{
				label: strings(['total', 'dispatched', 'quty']),
				key: (item) => displayItem(item.total_dispatched_quantity),
				mobile: true,
			},

			{
				label: strings(['total', 'pending', 'quty']),
				key: (item) => displayItem(item.total_pending_quantity),
				mobile: true,
			},
			{
				label: strings(['plan', 'from', 'yesterday']),
				key: (item) => displayItem(item.yesterday_planned_quantity),
				mobile: true,
			},
			{
				label: strings(['dispatched', 'yesterday']),
				key: (item) => displayItem(item.yesterday_dispatched_quantity),
				mobile: true,
			},

			{
				label: strings(['new', 'plan']),
				key: (item) => displayItem(item.today_planned_quantity),
				mobile: true,
			},
			{
				label: strings(['new', 'plan', 'dispatched', 'quty']),
				key: (item) => displayItem(item.today_dispatched_quantity),
				mobile: true,
			},
			{
				label: strings(['unplanned', 'dispatched']),
				key: (item) => displayItem(item.unplanned_dispatched_quantity),
				mobile: true,
			},
			// v2 Table enables sorting by default; keep all columns non-sortable.
		].map((col) => ({ ...col, sortable: false }))
	}, [])

	const detailedDispatchReportColumns = useMemo(() => {
		return [
			{
				label: strings('region'),
				key: (item) => item?.region ?? '-',
				mobile: true,
			},
			{
				label: strings('logistics_handler'),
				key: (item) => item?.logistics_handler ?? '-',
				mobile: true,
			},
			{
				label: strings('age'),
				key: (item) => item?.age ?? '-',
				mobile: true,
			},
			{
				label: strings('plan', 'quantity'),
				key: (item) => item?.plan_quantity ?? '-',
				mobile: true,
			},
			{
				label: strings('supplier', 'name'),
				key: (item) => item?.supplier_name ?? '-',
				mobile: true,
			},
			{
				label: strings('buyer', 'name'),
				key: (item) => item?.buyer_name ?? '-',
				mobile: true,
			},
			// {
			// 	label: strings('supply', 'spoc'),
			// 	key: 'supply_spoc',
			// 	mobile: true,
			// },
			{
				label: strings('pending', 'quantity'),
				key: (item) => item?.pending_quantity ?? '-',
				mobile: true,
			},
			{
				label: strings('dispatched', 'quantity'),
				key: (item) => item?.dispatched_quantity ?? '-',
				mobile: true,
			},
		].map((col) => ({ ...col, sortable: false }))
	}, [])

	const sortedReportByPlatform = useMemo(
		() => [...reportByPlatform].sort((a, b) => a?.platform?.localeCompare(b?.platform)),
		[reportByPlatform]
	)

	const sortedReportByDispatch = useMemo(
		() => [...reportBydDispatch].sort((a, b) => a?.region?.localeCompare(b?.region)),
		[reportBydDispatch]
	)

	return (
		<Wrapper>
			<TableContainer>
				<PageLevelTableWrapper>
					<SectionHeader>{strings(['dispatch', 'plan', 'report'])}</SectionHeader>
					<TableV2
						data={sortedReportByPlatform}
						columns={reportByPlatformColumns}
						rowClickable={false}
						hideFooter
						// v2 Table always flex-grows; kept it like old height fullheight={flase}
						style={{ flexGrow: 0 }}
					/>
				</PageLevelTableWrapper>
			</TableContainer>
			<TableContainer>
				<PageLevelTableWrapper>
					<SectionHeader>{strings(['detailed', 'report'])}</SectionHeader>
					<TableV2
						data={sortedReportByDispatch}
						columns={detailedDispatchReportColumns}
						rowClickable={false}
						hideFooter
						style={{ flexGrow: 0 }}
					/>
				</PageLevelTableWrapper>
			</TableContainer>
		</Wrapper>
	)
}

export default ReportsList
